import { Modal } from "components/modal";
import { Button } from "components/button";
import { CloseCircleGreyIcon, CloseIconCircle } from "assets";

interface AssessCandidatesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const AssessCandidatesModal: React.FC<AssessCandidatesModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal show={isOpen} close={onClose}>
      <div className="bg-white rounded-2xl w-full max-w-[480px] p-5 relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-2.5 right-3 p-1 hover:opacity-70 transition-opacity"
        >
          <CloseCircleGreyIcon className="w-8 h-8" />
        </button>

        {/* Content */}
        <div className="text-center pt-8">
          <h2 className="text-3xl font-bold text-[#012169] mb-6">
            Assess Candidates
          </h2>

          <p className="text-gray-500 mb-8 leading-relaxed text-base">
            You're about to create an <span className="font-semibold text-[#012169]">Assessment</span> for the
            selected candidates, but you can also invite
            additional candidates.
          </p>

          <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 mb-6">
          <p className="text-xs text-blue-700">
            These candidates will be automatically added to the invite list when
            you create a new assessment. You can review and modify the list
            before sending invitations.
          </p>
        </div>

          {/* Continue Button */}
          <Button
            type="fill"
            onClick={onConfirm}
            className="!w-[50%] mx-auto !py-4 !bg-[#012169] hover:!bg-[#012169]/90 !border-none !rounded-lg !text-base !font-medium"
          >
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export { AssessCandidatesModal };
